import React from 'react'
import { AiOutlineWarning } from 'react-icons/ai'
import { AtencaoWrapper } from '../style'

const Atencao = () => {
  return (
    <AtencaoWrapper>
      <div className="container">
        <AiOutlineWarning className="icon" size={50} />
        <span>
          Empréstimo pessoal com segurança. <br />A Riber, não solicita nenhum
          pagamento antecipado para liberar o seu empréstimo pessoal
        </span>
      </div>
    </AtencaoWrapper>
  )
}

export default Atencao
